import React from 'react';
import Box from "@mui/material/Box";
import {useSelector} from "react-redux";
import Tab from "@mui/material/Tab";
import TabList from "@mui/lab/TabList";
import TabContext from "@mui/lab/TabContext";
import {Icon} from "@mui/material";

const PerformanceTabs = ({performances, selectedPerformance, bestPerformance, handleSelect}) => {
    const performanceTypes =  useSelector(state => state.globals.messages.performanceTypes)
    const handleMenuClick = (value) => {
        handleSelect(value)
    };

    return (
        <Box>
            <TabContext value={selectedPerformance.id}>
                <TabList
                    variant="scrollable"
                    scrollButtons="false"
                    onChange={handleMenuClick}
                    aria-label="Performances"
                    sx={{
                        minHeight:'32px',
                        '& .MuiTabScrollButton-root':{
                            width:'inherit',
                        },
                    }}
                >
                    <Tab key={bestPerformance.id}
                         onClick={() => {handleMenuClick(bestPerformance.id)}}
                         icon={<Icon><img src={`/etc/img/performance-${bestPerformance.type}.svg`}/></Icon>}
                         value={bestPerformance.id}
                         sx={{
                             minWidth:'24px',
                             minHeight:'32px',
                             padding:'2px .75em',
                         }}
                    />

                    {
                        performances.map(p => {
                            return (p.id !== bestPerformance.id) ?
                                <Tab key={p.id}
                                     onClick={() => {handleMenuClick(p.id)}}
                                     icon={<Icon><img src={`/etc/img/performance-${p.type}.svg`}/></Icon>}
                                     value={p.id}
                                     sx={{
                                         minWidth:'24px',
                                         minHeight:'32px',
                                         padding:'2px .75em',
                                     }}
                                />
                                :
                                undefined
                        })
                    }
                </TabList>
            </TabContext>
        </Box>
    )
}

export default PerformanceTabs